/**
 * external libs
 */
import {Outlet, Route, Routes} from "react-router";
import React, {Suspense, useMemo} from "react";
/**
 * components
 */
import Layout from "../Layout";

/**
 * routes
 */
import {webRoutes} from "./routes/web.routes";
import {WorkspaceProvider} from "../../context/workspace.context";
import TaskGlobalSearchBridge from "../TaskGlobalSearchBridge";
import {WebsocketProvider} from "../../context/websocket.context";
import {TaskApproveProvider} from "../../context/taskApprove.context";

export default function RoutesComponent() {
    const routes = useMemo(() => webRoutes(), [])

    return (
            <Routes>
                <Route
                    element={
                        <WebsocketProvider>
                            <TaskApproveProvider>
                                <WorkspaceProvider>
                                    <TaskGlobalSearchBridge />
                                    <Layout>
                                        <Outlet />
                                    </Layout>
                                </WorkspaceProvider>
                            </TaskApproveProvider>
                        </WebsocketProvider>
                    }
                >
                    {routes.withLayout.map((route, i) => (
                        <route.layout
                            exact={route.exact}
                            key={`with-layout-${i}`}
                            path={route.path}
                            element={route.element}
                        />
                    ))}
                </Route>
            </Routes>
    )
}

